import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBriefcaseFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.25 3.5A2.25 2.25 0 0 0 9 5.75V6h7v-.25a2.25 2.25 0 0 0-2.25-2.25zM17.5 6v-.25A3.75 3.75 0 0 0 13.75 2h-2.5A3.75 3.75 0 0 0 7.5 5.75V6H6.25A3.75 3.75 0 0 0 2.5 9.75v7.5A3.75 3.75 0 0 0 6.25 21h12.5a3.75 3.75 0 0 0 3.75-3.75v-7.5A3.75 3.75 0 0 0 18.75 6z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBriefcaseFilled);
export default ForwardRef;
